import { createFileRoute, Outlet } from '@tanstack/react-router'
import { MonitoringProcessesWidget } from '@/widgets/monitoring-processes-widget'

export const Route = createFileRoute('/_auth/administration/monitoring/processes')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <MonitoringProcessesWidget />
      <Outlet />
    </>
  )
}
